import { InputTextField } from '@abbott-components/core';
import Stack from '@mui/material/Stack';
import { JSONSchema7 } from 'json-schema';
import { useContext, useEffect, useRef } from 'react';
import ControlState from '../../Shared/controlState';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';
import { WorkflowEngineContext } from '../../WorkflowEngine/workflowEngineReducer';

export default (control: ControlState) => {
  const { state } = useContext(WorkflowEngineContext);

  const { isReadOnlyView } = state;

  const properties = control.schema?.properties as JSONSchema7Properties;

  const labelSchema = properties['label'] as JSONSchema7;

  const fieldWrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    fieldWrapperRef.current
      ?.querySelector('input[type=number]')
      ?.setAttribute('step', 'any');
  }, []);

  return (
    <Stack ref={fieldWrapperRef} sx={{ minWidth: '100%' }}>
      <InputTextField
        label={labelSchema?.default as string}
        name={control.id}
        type="number"
        isDisabled={isReadOnlyView}
      />
    </Stack>
  );
};
